import React from 'react'

const useToggle = (initialValue = false): [boolean, () => void, (val: boolean) => void] => {
  const [value, setValue] = React.useState(initialValue)
  const toggle = React.useCallback(() => {
    setValue((v) => !v)
  }, [])
  return [value, toggle, setValue]
}

export default useToggle
